import download from 'downloadjs';

export const API_URL = '/rest';

export function callDownload(endpoint, method = 'GET', fileName = 'file', body) {
  let extension;
  return fetch(`${API_URL}/${endpoint}`, {
    ...(['POST', 'PATCH', 'PUT'].indexOf(method) !== -1)
      ? { headers: { 'Content-Type': 'application/json' } }
      : {},
    method,
    credentials: 'include',
    body: JSON.stringify(body),
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (contentType === 'application/json') {
        return Promise.reject(response.json().then(json => json.data));
      }
      switch (contentType) {
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          extension = 'xlsx';
          break;
        case 'text/csv':
          extension = 'csv';
          break;
        case 'text/txt; charset=utf-8':
          extension = 'txt';
          break;
        default:
          extension = null;
      }
      return response.blob();
    })
    .then(response =>
      download(response, extension ? `${fileName}.${extension}` : fileName))
    .catch(data => data);
}

export default function callApi(endpoint, method = 'GET', body, applicationJson = true, headers = {}) {
  return fetch(endpoint.indexOf('http') !== -1 ? endpoint : `${API_URL}/${endpoint}`, {
    ...Object.keys(headers).length > 0 ? { headers } : {},
    ...(applicationJson && ['POST', 'PATCH', 'PUT'].indexOf(method) !== -1)
      ? { headers: { 'Content-Type': 'application/json', ...headers } }
      : {},
    ...method === 'GET' && !process.env.REACT_APP_API_ROOT && endpoint.indexOf('http') === -1
      ? { headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        ...headers,
      } } : {},
    method,
    body: applicationJson ? JSON.stringify(body) : body,
    credentials: 'include',
  })
    .then(response => response.json().then(
      json => ({ json, response }),
      () => Promise.reject({ data: { error: `Server error ${response.status}: ${response.statusText}` } })),
    )
    .then(({ json, response }) => { 
      if (!response.ok) {
        return Promise.reject(json);
      }
      return json;
    }, (err) => {
      if (!err.data) {
        return Promise.reject({ data: { error: err.toString() } });
      }
      return Promise.reject(err);
    });
}

export function abortableCallApi(endpoint, method = 'GET', body, applicationJson = true) {
  const controller = new window.AbortController();
  const { signal } = controller;
  return {
    res: fetch(endpoint.indexOf('http') !== -1 ? endpoint : `${API_URL}/${endpoint}`, {
      ...(applicationJson && ['POST', 'PATCH', 'PUT'].indexOf(method) !== -1)
        ? { headers: { 'Content-Type': 'application/json' } }
        : {},
      ...method === 'GET' && !process.env.REACT_APP_API_ROOT && endpoint.indexOf('http') === -1
        ? { headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
        } } : {},
      method,
      body: applicationJson ? JSON.stringify(body) : body,
      ...endpoint.indexOf('http') === -1 ? { credentials: 'include' } : {},
      signal,
    })
      .then(response => response.json().then(
        json => ({ json, response }),
        () => Promise.reject({ data: { error: `Server error ${response.status}: ${response.statusText}` } })),
      )
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json);
        }

        return json;
      }, (err) => {
        if (!err.data) {
          return Promise.reject({ data: { error: err.toString() } });
        }
        return Promise.reject(err);
      }),
    abort: () => controller.abort(),
  };
}



// WEBPACK FOOTER //
// ./src/utils/callApi.js